import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '../../../../../../common/Icon';
import {
  BodyThree,
  SubtitleThree
} from '../../../../../../styles/theme/default/typography';

const Wrapper = styled.div`
  padding: 20px;
  border-top: 1px solid #d8d8d8;

  .title-open-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-container {
    margin-top: 30px;
  }
`;

function ProductDescription({ productData, openByDefault }) {
  const [open, setOpen] = useState(openByDefault);
  return (
    <Wrapper>
      <div className="title-open-btn" onClick={() => setOpen(!open)}>
        <SubtitleThree bold={true}>Product Description</SubtitleThree>
        <Icon
          icon={`ti-arrow-${open ? 'up' : 'down'}`}
          size={12}
          color="black"
        />
      </div>
      {open && (
        <div className="content-container">
          <BodyThree>{productData?.frame.description}</BodyThree>

          {/* {productData.bundle_products?.length ? (
            <Bundle productData={productData} />
          ) : (
            ''
          )} */}
        </div>
      )}
    </Wrapper>
  );
}

export default ProductDescription;
